var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,6.7c0.1,0,0.2-0.1,0.2-0.3c0-0.1,0-0.2-0.1-0.3c-0.2-0.2-0.5-0.2-0.6,0L8,9.3L4.8,6.1C4.7,6,4.6,6,4.5,6 S4.3,6,4.2,6.1C4.1,6.2,4,6.3,4,6.4s0,0.2,0.1,0.3L8,10.6L11.8,6.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownArrow);
export default __webpack_public_path__ + "static/media/icon-dropdown-arrow.2755e3417f1d4272f588bfa8f2fb8a57.svg";
export { ForwardRef as ReactComponent };